import { useState } from "react";
import confetti from "canvas-confetti";
import { Trophy } from "lucide-react";

const QS = [
  { q: "How long should you brush your teeth?", o: ["10 seconds", "2 minutes", "1 hour"], a: 1 },
  { q: "How many times a day should you brush?", o: ["Twice", "Once a week", "Never"], a: 0 },
  { q: "Which snack is best for your teeth?", o: ["Sticky toffee", "Crunchy apple", "Fizzy cola"], a: 1 },
  { q: "How many baby teeth do kids usually have?", o: ["10", "20", "32"], a: 1 },
  { q: "What do sugar bugs love to eat?", o: ["Sugar", "Water", "Carrots"], a: 0 },
];

export const ToothQuiz = () => {
  const [i, setI] = useState(0);
  const [score, setScore] = useState(0);
  const [picked, setPicked] = useState(null);
  const done = i >= QS.length;

  const pick = (k) => {
    if (picked !== null) return;
    setPicked(k);
    const s = score + (k === QS[i].a ? 1 : 0);
    if (k === QS[i].a) setScore(s);
    setTimeout(() => {
      setPicked(null); setI(i + 1);
      if (i + 1 === QS.length && s >= 4) confetti({ particleCount: 120, spread: 90 });
    }, 900);
  };

  if (done) {
    return (
      <div className="flex h-full flex-col items-center justify-center rounded-[2.5rem] bg-[#f3f0ff] p-10 text-center" data-testid="tooth-quiz">
        <Trophy className="h-16 w-16 text-[#f5b82e]" />
        <p className="font-display mt-4 text-3xl font-bold text-slate-800" data-testid="tooth-quiz-score">{score} / {QS.length}</p>
        <p className="mt-2 font-semibold text-slate-600">{score >= 4 ? "You're a certified Tooth Hero!" : "Great try! Play again to become a Tooth Hero."}</p>
        <button onClick={() => { setI(0); setScore(0); }} data-testid="tooth-quiz-restart"
          className="btn-pop mt-6 rounded-full bg-slate-900 px-6 py-3 font-bold text-white">Play again</button>
      </div>
    );
  }

  const q = QS[i];
  return (
    <div className="rounded-[2.5rem] bg-[#f3f0ff] p-8 sm:p-10" data-testid="tooth-quiz">
      <p className="text-xs font-bold uppercase tracking-widest text-violet-700">Tooth Hero quiz · {i + 1} of {QS.length}</p>
      <h2 className="mt-3 text-2xl font-bold sm:text-3xl" data-testid="tooth-quiz-question">{q.q}</h2>
      <div className="mt-8 space-y-3">
        {q.o.map((o, k) => {
          const state = picked === null ? "border-slate-200 bg-white hover:border-violet-400" : k === q.a ? "border-teal-600 bg-teal-100" : k === picked ? "border-[#ff6b6b] bg-[#fff1f1]" : "border-slate-200 bg-white opacity-60";
          return (
            <button key={o} onClick={() => pick(k)} data-testid="tooth-quiz-option"
              className={`font-display w-full rounded-2xl border-[3px] px-5 py-4 text-left text-lg font-semibold text-slate-800 transition-colors ${state}`}>{o}</button>
          );
        })}
      </div>
      <p className="mt-6 text-sm font-bold text-slate-500">Score: {score}</p>
    </div>
  );
};
